import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface MailIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  ref?: React.RefObject<SVGSVGElement>;
}

const MailIcon = forwardRef<SVGSVGElement, MailIconProps>(
  ({ className, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      {...props}
    >
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  )
);

MailIcon.displayName = "MailIcon";

export { MailIcon };

